import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Overview from 'containers/Overview';
import { clearGuardianStudentDocumentations } from 'actions/documents';
import { clearGuardianStudentPosts } from 'actions/posts';
import { setPageTitle } from 'actions/header';
import { translate } from '@haldor/ui';
var IndexWrapper = /*#__PURE__*/function (_Component) {
  function IndexWrapper(props) {
    _classCallCheck(this, IndexWrapper);
    return _callSuper(this, IndexWrapper, [props]);
  }
  _inherits(IndexWrapper, _Component);
  return _createClass(IndexWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.clearGuardianStudentDocumentations();
      this.props.clearGuardianStudentPosts();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.students == null) {
        return /*#__PURE__*/React.createElement("div", null);
      } else {
        var student = this.props.student;
        if (student != null && student.schools != null) {
          return /*#__PURE__*/React.createElement(Overview, null);
        } else {
          return /*#__PURE__*/React.createElement("div", {
            className: "login-content"
          }, /*#__PURE__*/React.createElement("h1", null, this.props.translate('Something went wrong')), /*#__PURE__*/React.createElement("p", {
            className: "login-content__subtitle"
          }, this.props.translate('The active student doesnt seem to belong to any school.'), /*#__PURE__*/React.createElement("br", null), this.props.translate('Contact your school for help.')));
        }
      }
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    student: state.User.activeStudent,
    students: state.guardians.students,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  clearGuardianStudentDocumentations: clearGuardianStudentDocumentations,
  clearGuardianStudentPosts: clearGuardianStudentPosts,
  setPageTitle: setPageTitle
})(IndexWrapper);